module.exports = __webpack_public_path__ + "img/C08TechDharma_ua.c9a651b1.webp";